import React from 'react';
import './Preloader.css';

export default function Preloader() {
  return (
    <div className="preloader-overlay">
      <div className="preloader-content">
        <div className="preloader-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        <div className="preloader-text">
          <span>Loading</span>
          <span className="dots">...</span>
        </div>
      </div>
    </div>
  );
} 